(() => {
  if (window.productCardQuickBuyTwoStageInitialized) {
    return;
  }

  window.productCardQuickBuyTwoStageInitialized = true;

  const desktopMediaQuery = window.matchMedia(
    '(min-width: 700px) and (hover: hover) and (pointer: fine)'
  );

  function getProductCard(element) {
    if (!(element instanceof Element)) {
      return null;
    }

    return element.closest('.product-card');
  }

  function getQuickBuy(card) {
    if (!card) {
      return null;
    }

    return card.querySelector('[data-product-card-quick-buy]');
  }

  function hasFloatingElement(card) {
    if (!card) {
      return false;
    }

    return Boolean(
      card.querySelector(
        '.product-card-paula-badge, .product-card-tags--inside'
      )
    );
  }

  function measureCompactHeight(card) {
    const quickBuy = getQuickBuy(card);

    if (!quickBuy) {
      return 0;
    }

    const button = quickBuy.querySelector(
      '.product-card__quick-add-button'
    );

    if (!button) {
      card.style.setProperty(
        '--product-card-quick-buy-compact-height',
        '0px'
      );

      return 0;
    }

    const compactHeight = Math.ceil(
      Math.max(
        button.getBoundingClientRect().height,
        button.offsetHeight,
        button.scrollHeight,
        0
      )
    );

    card.style.setProperty(
      '--product-card-quick-buy-compact-height',
      `${compactHeight}px`
    );

    return compactHeight;
  }

  function measureExpandedHeight(card) {
    const quickBuy = getQuickBuy(card);

    if (!quickBuy) {
      return 0;
    }

    const sizeView = quickBuy.querySelector('.quick_size_view');
    const sizeGrid = quickBuy.querySelector('.product-size-hover-grid');

    const sizeViewHeight = sizeView
      ? Math.max(
          sizeView.getBoundingClientRect().height,
          sizeView.offsetHeight,
          sizeView.scrollHeight
        )
      : 0;

    const sizeGridHeight = sizeGrid
      ? Math.max(
          sizeGrid.getBoundingClientRect().height,
          sizeGrid.offsetHeight,
          sizeGrid.scrollHeight
        )
      : 0;

    const expandedHeight = Math.ceil(
      Math.max(
        sizeViewHeight,
        sizeGridHeight,
        0
      )
    );

    card.style.setProperty(
      '--product-card-quick-buy-expanded-height',
      `${expandedHeight}px`
    );

    return expandedHeight;
  }

  function setCompactStage(card) {
    if (
      !desktopMediaQuery.matches ||
      !hasFloatingElement(card)
    ) {
      return;
    }

    measureCompactHeight(card);

    card.setAttribute(
      'data-quick-buy-stage',
      'compact'
    );
  }

  function setExpandedStage(card) {
    if (
      !desktopMediaQuery.matches ||
      !hasFloatingElement(card)
    ) {
      return;
    }

    measureCompactHeight(card);
    measureExpandedHeight(card);

    card.setAttribute(
      'data-quick-buy-stage',
      'expanded'
    );
  }

  function resetStage(card) {
    if (!card) {
      return;
    }

    card.removeAttribute('data-quick-buy-stage');
  }

  document.addEventListener('pointerover', (event) => {
    if (!desktopMediaQuery.matches) {
      return;
    }

    const card = getProductCard(event.target);

    if (
      !card ||
      !hasFloatingElement(card)
    ) {
      return;
    }

    const quickBuy = getQuickBuy(card);

    if (!quickBuy) {
      return;
    }

    const previousElement = event.relatedTarget;

    if (
      !previousElement ||
      !card.contains(previousElement)
    ) {
      setCompactStage(card);
    }

    if (
      quickBuy.contains(event.target) &&
      (
        !previousElement ||
        !quickBuy.contains(previousElement)
      )
    ) {
      setExpandedStage(card);
    }
  });

  document.addEventListener('pointerout', (event) => {
    if (!desktopMediaQuery.matches) {
      return;
    }

    const card = getProductCard(event.target);

    if (
      !card ||
      !hasFloatingElement(card)
    ) {
      return;
    }

    const quickBuy = getQuickBuy(card);

    if (!quickBuy) {
      return;
    }

    const nextElement = event.relatedTarget;

    if (
      quickBuy.contains(event.target) &&
      (
        !nextElement ||
        !quickBuy.contains(nextElement)
      )
    ) {
      if (
        nextElement &&
        card.contains(nextElement)
      ) {
        setCompactStage(card);
      }
    }

    if (
      !nextElement ||
      !card.contains(nextElement)
    ) {
      resetStage(card);
    }
  });
})();
